import {
  useEffect, useState,
} from 'react';
import { Device } from '../types';
import { getDeviceInfoRequest } from '../utils/api';
import { useDeviceId } from './useDeviceId';

type UseGetDeviceInfoReturn = {
  isLoading: boolean,
  device?: Device,
  isPending: boolean,
  isError: boolean,
};

// eslint-disable-next-line import/prefer-default-export,@typescript-eslint/explicit-module-boundary-types
export const useGetDeviceInfo = (): UseGetDeviceInfoReturn => {
  const deviceId = useDeviceId();
  const [state, setState] = useState({
    isLoading: true,
    device: undefined as Device | undefined,
    isPending: false,
    isError: false,
  });

  useEffect(() => {
    const getDeviceInfo = async (): Promise<void> => {
      try {
        const response = await getDeviceInfoRequest({ deviceId });

        if (response.device) {
          setState({
            isLoading: false, device: response.device, isPending: false, isError: false,
          });
        } else if (response.isPending === true) {
          setState({
            isLoading: false, device: undefined, isPending: true, isError: false,
          });
        } else {
          // No device and not pending — request failed or returned an unexpected response
          setState({
            isLoading: false, device: undefined, isPending: false, isError: true,
          });
        }
      } catch (error) {
        console.error('Error getting device info:', error);
        setState({
          isLoading: false, device: undefined, isPending: false, isError: true,
        });
      }
    };

    getDeviceInfo();
    // eslint-disable-next-line
  }, []);

  return state;
};
